module.exports = __webpack_public_path__ + "media/apps/app-download-d-phone-b87ee907.webp";